import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EuEtsComponent } from './eu-ets.component';

const routes: Routes = [
  {
    path: '',
    component: EuEtsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EuEtsRoutingModule {}
